import { useState } from 'react';
import { useEventListener } from 'src/core/hooks/useEventListener';
const MEMBERSHIP_ADMIN_MENU_HIDDEN_BREAKPOINT = 992;
function isHidden(screenWidth) {
    return screenWidth < MEMBERSHIP_ADMIN_MENU_HIDDEN_BREAKPOINT;
}
function getInitialStatus() {
    return document.querySelector('hot-menu')?.hasAttribute('open') ? 'open' : 'minimized';
}
export function useMembershipAdminMenu(screenWidth) {
    const [status, setStatus] = useState(getInitialStatus());
    useEventListener('openmenu', () => setStatus('open'));
    useEventListener('closemenu', () => setStatus('minimized'));
    if (isHidden(screenWidth)) {
        return {
            status: 'hidden',
            width: 0
        };
    }
    return {
        status,
        width: status === 'open' ? 'var(--structure-menu-width)' : 'var(--structure-menu-minimized-width)'
    };
}
